// extracted by mini-css-extract-plugin
export default {"container":"CreateEstimateAttachment_container__M3ag3"};